"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               unknown
// source: rocketchat/api/event.proto
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetEvent = exports.ReplyEvent_Notification = exports.ReplyEvent = exports.UserMentionEvent_Notification = exports.UserMentionEvent = exports.TerminateVoiceChannelEvent = exports.JoinVoiceChannelEvent = exports.UpdateMessageEvent = exports.UpdateBubbleGroupEvent = exports.RenewChannelEvent = exports.LeaveMemberEvent = exports.JoinMemberEvent = exports.ReadMessageEvent = exports.NewMessageEvent_Notification = exports.NewMessageEvent = exports.MessageStyleNotification = exports.DispatchEvent = exports.LeaveMemberEvent_By = exports.NewMessageEvent_Notification_Type = exports.TerminateVoiceChannelReason = exports.protobufPackage = void 0;
exports.terminateVoiceChannelReasonFromJSON = terminateVoiceChannelReasonFromJSON;
exports.terminateVoiceChannelReasonToJSON = terminateVoiceChannelReasonToJSON;
exports.terminateVoiceChannelReasonToNumber = terminateVoiceChannelReasonToNumber;
exports.newMessageEvent_Notification_TypeFromJSON = newMessageEvent_Notification_TypeFromJSON;
exports.newMessageEvent_Notification_TypeToJSON = newMessageEvent_Notification_TypeToJSON;
exports.newMessageEvent_Notification_TypeToNumber = newMessageEvent_Notification_TypeToNumber;
exports.leaveMemberEvent_ByFromJSON = leaveMemberEvent_ByFromJSON;
exports.leaveMemberEvent_ByToJSON = leaveMemberEvent_ByToJSON;
exports.leaveMemberEvent_ByToNumber = leaveMemberEvent_ByToNumber;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const timestamp_1 = require("../../google/protobuf/timestamp");
const model_1 = require("./model");
const relay_event_1 = require("./relay_event");
exports.protobufPackage = "api";
var TerminateVoiceChannelReason;
(function (TerminateVoiceChannelReason) {
    TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED"] = "TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED";
    /** TERMINATE_VOICE_CHANNEL_REASON_BY_USER - 유저가 직접 거절하거나 취소하는 경우 */
    TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_BY_USER"] = "TERMINATE_VOICE_CHANNEL_REASON_BY_USER";
    /** TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING - 통화중 상태인 경우 */
    TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING"] = "TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING";
    /** TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT - 일정시간 후에 음성채팅을 취소하거나 거절한 경우 */
    TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT"] = "TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT";
    /** TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED - 디바이스에서 음성채팅을 위한 권한이 없어서 통화를 종료한 경우 */
    TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED"] = "TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED";
})(TerminateVoiceChannelReason || (exports.TerminateVoiceChannelReason = TerminateVoiceChannelReason = {}));
function terminateVoiceChannelReasonFromJSON(object) {
    switch (object) {
        case 0:
        case "TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED":
            return TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED;
        case 1:
        case "TERMINATE_VOICE_CHANNEL_REASON_BY_USER":
            return TerminateVoiceChannelReason.TERMINATE_VOICE_CHANNEL_REASON_BY_USER;
        case 2:
        case "TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING":
            return TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING;
        case 3:
        case "TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT":
            return TerminateVoiceChannelReason.TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT;
        case 4:
        case "TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED":
            return TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED;
        default:
            return TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED;
    }
}
function terminateVoiceChannelReasonToJSON(object) {
    switch (object) {
        case TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED:
            return "TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED";
        case TerminateVoiceChannelReason.TERMINATE_VOICE_CHANNEL_REASON_BY_USER:
            return "TERMINATE_VOICE_CHANNEL_REASON_BY_USER";
        case TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING:
            return "TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING";
        case TerminateVoiceChannelReason.TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT:
            return "TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT";
        case TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED:
            return "TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED";
        default:
            return "TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED";
    }
}
function terminateVoiceChannelReasonToNumber(object) {
    switch (object) {
        case TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED:
            return 0;
        case TerminateVoiceChannelReason.TERMINATE_VOICE_CHANNEL_REASON_BY_USER:
            return 1;
        case TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING:
            return 2;
        case TerminateVoiceChannelReason.TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT:
            return 3;
        case TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED:
            return 4;
        default:
            return 0;
    }
}
var NewMessageEvent_Notification_Type;
(function (NewMessageEvent_Notification_Type) {
    /** TYPE_UNSPECIFIED - 일반 채팅방 탭으로 간주함 */
    NewMessageEvent_Notification_Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /** NORMAL - 일반 채팅방 탭에 대한 알림 */
    NewMessageEvent_Notification_Type["NORMAL"] = "NORMAL";
    /** BIZ_CHAT - 비즈 채팅방 탭에 대한 알림 */
    NewMessageEvent_Notification_Type["BIZ_CHAT"] = "BIZ_CHAT";
})(NewMessageEvent_Notification_Type || (exports.NewMessageEvent_Notification_Type = NewMessageEvent_Notification_Type = {}));
function newMessageEvent_Notification_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return NewMessageEvent_Notification_Type.TYPE_UNSPECIFIED;
        case 1:
        case "NORMAL":
            return NewMessageEvent_Notification_Type.NORMAL;
        case 2:
        case "BIZ_CHAT":
            return NewMessageEvent_Notification_Type.BIZ_CHAT;
        default:
            return NewMessageEvent_Notification_Type.TYPE_UNSPECIFIED;
    }
}
function newMessageEvent_Notification_TypeToJSON(object) {
    switch (object) {
        case NewMessageEvent_Notification_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case NewMessageEvent_Notification_Type.NORMAL:
            return "NORMAL";
        case NewMessageEvent_Notification_Type.BIZ_CHAT:
            return "BIZ_CHAT";
        default:
            return "TYPE_UNSPECIFIED";
    }
}
function newMessageEvent_Notification_TypeToNumber(object) {
    switch (object) {
        case NewMessageEvent_Notification_Type.TYPE_UNSPECIFIED:
            return 0;
        case NewMessageEvent_Notification_Type.NORMAL:
            return 1;
        case NewMessageEvent_Notification_Type.BIZ_CHAT:
            return 2;
        default:
            return 0;
    }
}
var LeaveMemberEvent_By;
(function (LeaveMemberEvent_By) {
    LeaveMemberEvent_By["SELF"] = "SELF";
    LeaveMemberEvent_By["OWNER"] = "OWNER";
    LeaveMemberEvent_By["ADMIN"] = "ADMIN";
})(LeaveMemberEvent_By || (exports.LeaveMemberEvent_By = LeaveMemberEvent_By = {}));
function leaveMemberEvent_ByFromJSON(object) {
    switch (object) {
        case 0:
        case "SELF":
            return LeaveMemberEvent_By.SELF;
        case 1:
        case "OWNER":
            return LeaveMemberEvent_By.OWNER;
        case 2:
        case "ADMIN":
            return LeaveMemberEvent_By.ADMIN;
        default:
            return LeaveMemberEvent_By.SELF;
    }
}
function leaveMemberEvent_ByToJSON(object) {
    switch (object) {
        case LeaveMemberEvent_By.SELF:
            return "SELF";
        case LeaveMemberEvent_By.OWNER:
            return "OWNER";
        case LeaveMemberEvent_By.ADMIN:
            return "ADMIN";
        default:
            return "SELF";
    }
}
function leaveMemberEvent_ByToNumber(object) {
    switch (object) {
        case LeaveMemberEvent_By.SELF:
            return 0;
        case LeaveMemberEvent_By.OWNER:
            return 1;
        case LeaveMemberEvent_By.ADMIN:
            return 2;
        default:
            return 0;
    }
}
function createBaseDispatchEvent() {
    return {
        session_id: "",
        target_user_ids: [],
        biz_account_id: undefined,
        relay_event: undefined,
    };
}
exports.DispatchEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.session_id !== "") {
            writer.uint32(18).string(message.session_id);
        }
        for (const v of message.target_user_ids) {
            model_1.UserID.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.biz_account_id !== undefined) {
            writer.uint32(32).int64(message.biz_account_id);
        }
        if (message.relay_event !== undefined) {
            relay_event_1.RelayEvent.encode(message.relay_event, writer.uint32(402).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDispatchEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.target_user_ids.push(model_1.UserID.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.relay_event = relay_event_1.RelayEvent.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            target_user_ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.target_user_ids)
                ? object.target_user_ids.map((e) => model_1.UserID.fromJSON(e))
                : [],
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : undefined,
            relay_event: isSet(object.relay_event)
                ? relay_event_1.RelayEvent.fromJSON(object.relay_event)
                : undefined,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if ((_a = message.target_user_ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.target_user_ids = message.target_user_ids.map((e) => model_1.UserID.toJSON(e));
        }
        if (message.biz_account_id !== undefined) {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.relay_event !== undefined) {
            obj.relay_event = relay_event_1.RelayEvent.toJSON(message.relay_event);
        }
        return obj;
    },
    create(base) {
        return exports.DispatchEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseDispatchEvent();
        message.session_id = (_a = object.session_id) !== null && _a !== void 0 ? _a : "";
        message.target_user_ids =
            ((_b = object.target_user_ids) === null || _b === void 0 ? void 0 : _b.map((e) => model_1.UserID.fromPartial(e))) || [];
        message.biz_account_id = (_c = object.biz_account_id) !== null && _c !== void 0 ? _c : undefined;
        message.relay_event =
            (object.relay_event !== undefined && object.relay_event !== null)
                ? relay_event_1.RelayEvent.fromPartial(object.relay_event)
                : undefined;
        return message;
    },
};
function createBaseMessageStyleNotification() {
    return {
        title: "",
        subtitle: undefined,
        body: "",
        profile_image_url: "",
        thumbnail_image_url: undefined,
        landing_deeplink_url: "",
        is_silence: false,
        is_mute: false,
        is_read_only: false,
    };
}
exports.MessageStyleNotification = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.subtitle !== undefined) {
            writer.uint32(18).string(message.subtitle);
        }
        if (message.body !== "") {
            writer.uint32(26).string(message.body);
        }
        if (message.profile_image_url !== "") {
            writer.uint32(34).string(message.profile_image_url);
        }
        if (message.thumbnail_image_url !== undefined) {
            writer.uint32(42).string(message.thumbnail_image_url);
        }
        if (message.landing_deeplink_url !== "") {
            writer.uint32(50).string(message.landing_deeplink_url);
        }
        if (message.is_silence !== false) {
            writer.uint32(56).bool(message.is_silence);
        }
        if (message.is_mute !== false) {
            writer.uint32(64).bool(message.is_mute);
        }
        if (message.is_read_only !== false) {
            writer.uint32(72).bool(message.is_read_only);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMessageStyleNotification();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subtitle = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.body = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.profile_image_url = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.thumbnail_image_url = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.landing_deeplink_url = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.is_silence = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.is_mute = reader.bool();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.is_read_only = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            subtitle: isSet(object.subtitle)
                ? globalThis.String(object.subtitle)
                : undefined,
            body: isSet(object.body) ? globalThis.String(object.body) : "",
            profile_image_url: isSet(object.profile_image_url)
                ? globalThis.String(object.profile_image_url)
                : "",
            thumbnail_image_url: isSet(object.thumbnail_image_url)
                ? globalThis.String(object.thumbnail_image_url)
                : undefined,
            landing_deeplink_url: isSet(object.landing_deeplink_url)
                ? globalThis.String(object.landing_deeplink_url)
                : "",
            is_silence: isSet(object.is_silence)
                ? globalThis.Boolean(object.is_silence)
                : false,
            is_mute: isSet(object.is_mute)
                ? globalThis.Boolean(object.is_mute)
                : false,
            is_read_only: isSet(object.is_read_only)
                ? globalThis.Boolean(object.is_read_only)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.subtitle !== undefined) {
            obj.subtitle = message.subtitle;
        }
        if (message.body !== "") {
            obj.body = message.body;
        }
        if (message.profile_image_url !== "") {
            obj.profile_image_url = message.profile_image_url;
        }
        if (message.thumbnail_image_url !== undefined) {
            obj.thumbnail_image_url = message.thumbnail_image_url;
        }
        if (message.landing_deeplink_url !== "") {
            obj.landing_deeplink_url = message.landing_deeplink_url;
        }
        if (message.is_silence !== false) {
            obj.is_silence = message.is_silence;
        }
        if (message.is_mute !== false) {
            obj.is_mute = message.is_mute;
        }
        if (message.is_read_only !== false) {
            obj.is_read_only = message.is_read_only;
        }
        return obj;
    },
    create(base) {
        return exports.MessageStyleNotification.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = createBaseMessageStyleNotification();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.subtitle = (_b = object.subtitle) !== null && _b !== void 0 ? _b : undefined;
        message.body = (_c = object.body) !== null && _c !== void 0 ? _c : "";
        message.profile_image_url = (_d = object.profile_image_url) !== null && _d !== void 0 ? _d : "";
        message.thumbnail_image_url = (_e = object.thumbnail_image_url) !== null && _e !== void 0 ? _e : undefined;
        message.landing_deeplink_url = (_f = object.landing_deeplink_url) !== null && _f !== void 0 ? _f : "";
        message.is_silence = (_g = object.is_silence) !== null && _g !== void 0 ? _g : false;
        message.is_mute = (_h = object.is_mute) !== null && _h !== void 0 ? _h : false;
        message.is_read_only = (_j = object.is_read_only) !== null && _j !== void 0 ? _j : false;
        return message;
    },
};
function createBaseNewMessageEvent() {
    return {
        channel_id: "",
        sender_id: "0",
        sender_nickname: "",
        sender_profile: "",
        content: "",
        silence: false,
        mute: false,
        target_uri: "",
        resource_title: "",
        unread_count: undefined,
        notification_sound: "",
        message_id: "0",
        sender: undefined,
        biz_account_id: "0",
        notification: undefined,
        readonly: false,
        session_id: "",
        collapse_id: "",
        message_type: "",
        template_type: model_1.TemplateType.TEMPLATE_TYPE_UNSPECIFIED,
    };
}
exports.NewMessageEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.sender_id !== "0") {
            writer.uint32(16).int64(message.sender_id);
        }
        if (message.sender_nickname !== "") {
            writer.uint32(26).string(message.sender_nickname);
        }
        if (message.sender_profile !== "") {
            writer.uint32(34).string(message.sender_profile);
        }
        if (message.content !== "") {
            writer.uint32(42).string(message.content);
        }
        if (message.silence !== false) {
            writer.uint32(48).bool(message.silence);
        }
        if (message.mute !== false) {
            writer.uint32(56).bool(message.mute);
        }
        if (message.target_uri !== "") {
            writer.uint32(66).string(message.target_uri);
        }
        if (message.resource_title !== "") {
            writer.uint32(74).string(message.resource_title);
        }
        if (message.unread_count !== undefined) {
            model_1.UnreadCount.encode(message.unread_count, writer.uint32(82).fork())
                .ldelim();
        }
        if (message.notification_sound !== "") {
            writer.uint32(106).string(message.notification_sound);
        }
        if (message.message_id !== "0") {
            writer.uint32(112).int64(message.message_id);
        }
        if (message.sender !== undefined) {
            model_1.User.encode(message.sender, writer.uint32(122).fork()).ldelim();
        }
        if (message.biz_account_id !== "0") {
            writer.uint32(128).int64(message.biz_account_id);
        }
        if (message.notification !== undefined) {
            exports.NewMessageEvent_Notification.encode(message.notification, writer.uint32(138).fork()).ldelim();
        }
        if (message.readonly !== false) {
            writer.uint32(144).bool(message.readonly);
        }
        if (message.session_id !== "") {
            writer.uint32(162).string(message.session_id);
        }
        if (message.collapse_id !== "") {
            writer.uint32(170).string(message.collapse_id);
        }
        if (message.message_type !== "") {
            writer.uint32(178).string(message.message_type);
        }
        if (message.template_type !== model_1.TemplateType.TEMPLATE_TYPE_UNSPECIFIED) {
            writer.uint32(184).int32((0, model_1.templateTypeToNumber)(message.template_type));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNewMessageEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.sender_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.sender_nickname = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.sender_profile = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.silence = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.mute = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.resource_title = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.unread_count = model_1.UnreadCount.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.notification_sound = reader.string();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.sender = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.notification = exports.NewMessageEvent_Notification.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 144) {
                        break;
                    }
                    message.readonly = reader.bool();
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.collapse_id = reader.string();
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.message_type = reader.string();
                    continue;
                case 23:
                    if (tag !== 184) {
                        break;
                    }
                    message.template_type = (0, model_1.templateTypeFromJSON)(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            sender_id: isSet(object.sender_id)
                ? globalThis.String(object.sender_id)
                : "0",
            sender_nickname: isSet(object.sender_nickname)
                ? globalThis.String(object.sender_nickname)
                : "",
            sender_profile: isSet(object.sender_profile)
                ? globalThis.String(object.sender_profile)
                : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            silence: isSet(object.silence)
                ? globalThis.Boolean(object.silence)
                : false,
            mute: isSet(object.mute) ? globalThis.Boolean(object.mute) : false,
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            resource_title: isSet(object.resource_title)
                ? globalThis.String(object.resource_title)
                : "",
            unread_count: isSet(object.unread_count)
                ? model_1.UnreadCount.fromJSON(object.unread_count)
                : undefined,
            notification_sound: isSet(object.notification_sound)
                ? globalThis.String(object.notification_sound)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            sender: isSet(object.sender) ? model_1.User.fromJSON(object.sender) : undefined,
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : "0",
            notification: isSet(object.notification)
                ? exports.NewMessageEvent_Notification.fromJSON(object.notification)
                : undefined,
            readonly: isSet(object.readonly)
                ? globalThis.Boolean(object.readonly)
                : false,
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            collapse_id: isSet(object.collapse_id)
                ? globalThis.String(object.collapse_id)
                : "",
            message_type: isSet(object.message_type)
                ? globalThis.String(object.message_type)
                : "",
            template_type: isSet(object.template_type)
                ? (0, model_1.templateTypeFromJSON)(object.template_type)
                : model_1.TemplateType.TEMPLATE_TYPE_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.sender_id !== "0") {
            obj.sender_id = message.sender_id;
        }
        if (message.sender_nickname !== "") {
            obj.sender_nickname = message.sender_nickname;
        }
        if (message.sender_profile !== "") {
            obj.sender_profile = message.sender_profile;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.silence !== false) {
            obj.silence = message.silence;
        }
        if (message.mute !== false) {
            obj.mute = message.mute;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.resource_title !== "") {
            obj.resource_title = message.resource_title;
        }
        if (message.unread_count !== undefined) {
            obj.unread_count = model_1.UnreadCount.toJSON(message.unread_count);
        }
        if (message.notification_sound !== "") {
            obj.notification_sound = message.notification_sound;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.sender !== undefined) {
            obj.sender = model_1.User.toJSON(message.sender);
        }
        if (message.biz_account_id !== "0") {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.notification !== undefined) {
            obj.notification = exports.NewMessageEvent_Notification.toJSON(message.notification);
        }
        if (message.readonly !== false) {
            obj.readonly = message.readonly;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.collapse_id !== "") {
            obj.collapse_id = message.collapse_id;
        }
        if (message.message_type !== "") {
            obj.message_type = message.message_type;
        }
        if (message.template_type !== model_1.TemplateType.TEMPLATE_TYPE_UNSPECIFIED) {
            obj.template_type = (0, model_1.templateTypeToJSON)(message.template_type);
        }
        return obj;
    },
    create(base) {
        return exports.NewMessageEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const message = createBaseNewMessageEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.sender_id = (_b = object.sender_id) !== null && _b !== void 0 ? _b : "0";
        message.sender_nickname = (_c = object.sender_nickname) !== null && _c !== void 0 ? _c : "";
        message.sender_profile = (_d = object.sender_profile) !== null && _d !== void 0 ? _d : "";
        message.content = (_e = object.content) !== null && _e !== void 0 ? _e : "";
        message.silence = (_f = object.silence) !== null && _f !== void 0 ? _f : false;
        message.mute = (_g = object.mute) !== null && _g !== void 0 ? _g : false;
        message.target_uri = (_h = object.target_uri) !== null && _h !== void 0 ? _h : "";
        message.resource_title = (_j = object.resource_title) !== null && _j !== void 0 ? _j : "";
        message.unread_count =
            (object.unread_count !== undefined && object.unread_count !== null)
                ? model_1.UnreadCount.fromPartial(object.unread_count)
                : undefined;
        message.notification_sound = (_k = object.notification_sound) !== null && _k !== void 0 ? _k : "";
        message.message_id = (_l = object.message_id) !== null && _l !== void 0 ? _l : "0";
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? model_1.User.fromPartial(object.sender)
            : undefined;
        message.biz_account_id = (_m = object.biz_account_id) !== null && _m !== void 0 ? _m : "0";
        message.notification =
            (object.notification !== undefined && object.notification !== null)
                ? exports.NewMessageEvent_Notification.fromPartial(object.notification)
                : undefined;
        message.readonly = (_o = object.readonly) !== null && _o !== void 0 ? _o : false;
        message.session_id = (_p = object.session_id) !== null && _p !== void 0 ? _p : "";
        message.collapse_id = (_q = object.collapse_id) !== null && _q !== void 0 ? _q : "";
        message.message_type = (_r = object.message_type) !== null && _r !== void 0 ? _r : "";
        message.template_type = (_s = object.template_type) !== null && _s !== void 0 ? _s : model_1.TemplateType.TEMPLATE_TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseNewMessageEvent_Notification() {
    return {
        summary: "",
        nickname: "",
        message: "",
        large_image_url: "",
        is_circle_large_icon: false,
        type: NewMessageEvent_Notification_Type.TYPE_UNSPECIFIED,
        translated_push_title: "",
        message_style_notification: undefined,
    };
}
exports.NewMessageEvent_Notification = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.summary !== "") {
            writer.uint32(10).string(message.summary);
        }
        if (message.nickname !== "") {
            writer.uint32(18).string(message.nickname);
        }
        if (message.message !== "") {
            writer.uint32(26).string(message.message);
        }
        if (message.large_image_url !== "") {
            writer.uint32(34).string(message.large_image_url);
        }
        if (message.is_circle_large_icon !== false) {
            writer.uint32(40).bool(message.is_circle_large_icon);
        }
        if (message.type !== NewMessageEvent_Notification_Type.TYPE_UNSPECIFIED) {
            writer.uint32(48).int32(newMessageEvent_Notification_TypeToNumber(message.type));
        }
        if (message.translated_push_title !== "") {
            writer.uint32(58).string(message.translated_push_title);
        }
        if (message.message_style_notification !== undefined) {
            exports.MessageStyleNotification.encode(message.message_style_notification, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNewMessageEvent_Notification();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.summary = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.nickname = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.large_image_url = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.is_circle_large_icon = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.type = newMessageEvent_Notification_TypeFromJSON(reader.int32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.translated_push_title = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.message_style_notification = exports.MessageStyleNotification.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            summary: isSet(object.summary) ? globalThis.String(object.summary) : "",
            nickname: isSet(object.nickname)
                ? globalThis.String(object.nickname)
                : "",
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            large_image_url: isSet(object.large_image_url)
                ? globalThis.String(object.large_image_url)
                : "",
            is_circle_large_icon: isSet(object.is_circle_large_icon)
                ? globalThis.Boolean(object.is_circle_large_icon)
                : false,
            type: isSet(object.type)
                ? newMessageEvent_Notification_TypeFromJSON(object.type)
                : NewMessageEvent_Notification_Type.TYPE_UNSPECIFIED,
            translated_push_title: isSet(object.translated_push_title)
                ? globalThis.String(object.translated_push_title)
                : "",
            message_style_notification: isSet(object.message_style_notification)
                ? exports.MessageStyleNotification.fromJSON(object.message_style_notification)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.summary !== "") {
            obj.summary = message.summary;
        }
        if (message.nickname !== "") {
            obj.nickname = message.nickname;
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.large_image_url !== "") {
            obj.large_image_url = message.large_image_url;
        }
        if (message.is_circle_large_icon !== false) {
            obj.is_circle_large_icon = message.is_circle_large_icon;
        }
        if (message.type !== NewMessageEvent_Notification_Type.TYPE_UNSPECIFIED) {
            obj.type = newMessageEvent_Notification_TypeToJSON(message.type);
        }
        if (message.translated_push_title !== "") {
            obj.translated_push_title = message.translated_push_title;
        }
        if (message.message_style_notification !== undefined) {
            obj.message_style_notification = exports.MessageStyleNotification.toJSON(message.message_style_notification);
        }
        return obj;
    },
    create(base) {
        return exports.NewMessageEvent_Notification.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseNewMessageEvent_Notification();
        message.summary = (_a = object.summary) !== null && _a !== void 0 ? _a : "";
        message.nickname = (_b = object.nickname) !== null && _b !== void 0 ? _b : "";
        message.message = (_c = object.message) !== null && _c !== void 0 ? _c : "";
        message.large_image_url = (_d = object.large_image_url) !== null && _d !== void 0 ? _d : "";
        message.is_circle_large_icon = (_e = object.is_circle_large_icon) !== null && _e !== void 0 ? _e : false;
        message.type = (_f = object.type) !== null && _f !== void 0 ? _f : NewMessageEvent_Notification_Type.TYPE_UNSPECIFIED;
        message.translated_push_title = (_g = object.translated_push_title) !== null && _g !== void 0 ? _g : "";
        message.message_style_notification =
            (object.message_style_notification !== undefined &&
                object.message_style_notification !== null)
                ? exports.MessageStyleNotification.fromPartial(object.message_style_notification)
                : undefined;
        return message;
    },
};
function createBaseReadMessageEvent() {
    return {
        channel_id: "",
        message_id: "0",
        DEPRECATED: "0",
        target_uri: "",
        biz_account_id: "0",
        reader: undefined,
        session_id: "",
    };
}
exports.ReadMessageEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.DEPRECATED !== "0") {
            writer.uint32(24).int64(message.DEPRECATED);
        }
        if (message.target_uri !== "") {
            writer.uint32(34).string(message.target_uri);
        }
        if (message.biz_account_id !== "0") {
            writer.uint32(40).int64(message.biz_account_id);
        }
        if (message.reader !== undefined) {
            model_1.User.encode(message.reader, writer.uint32(50).fork()).ldelim();
        }
        if (message.session_id !== "") {
            writer.uint32(58).string(message.session_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReadMessageEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.DEPRECATED = longToString(reader.int64());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.reader = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            DEPRECATED: isSet(object.DEPRECATED)
                ? globalThis.String(object.DEPRECATED)
                : "0",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : "0",
            reader: isSet(object.reader) ? model_1.User.fromJSON(object.reader) : undefined,
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.DEPRECATED !== "0") {
            obj.DEPRECATED = message.DEPRECATED;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.biz_account_id !== "0") {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.reader !== undefined) {
            obj.reader = model_1.User.toJSON(message.reader);
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        return obj;
    },
    create(base) {
        return exports.ReadMessageEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseReadMessageEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.DEPRECATED = (_c = object.DEPRECATED) !== null && _c !== void 0 ? _c : "0";
        message.target_uri = (_d = object.target_uri) !== null && _d !== void 0 ? _d : "";
        message.biz_account_id = (_e = object.biz_account_id) !== null && _e !== void 0 ? _e : "0";
        message.reader = (object.reader !== undefined && object.reader !== null)
            ? model_1.User.fromPartial(object.reader)
            : undefined;
        message.session_id = (_f = object.session_id) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseJoinMemberEvent() {
    return {
        channel_id: "",
        member: undefined,
        biz_account_id: "0",
        session_id: "",
        member_count: 0,
        event_time: undefined,
    };
}
exports.JoinMemberEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.member !== undefined) {
            model_1.User.encode(message.member, writer.uint32(18).fork()).ldelim();
        }
        if (message.biz_account_id !== "0") {
            writer.uint32(24).int64(message.biz_account_id);
        }
        if (message.session_id !== "") {
            writer.uint32(34).string(message.session_id);
        }
        if (message.member_count !== 0) {
            writer.uint32(40).int32(message.member_count);
        }
        if (message.event_time !== undefined) {
            timestamp_1.Timestamp.encode(message.event_time, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseJoinMemberEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.member = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.member_count = reader.int32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.event_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            member: isSet(object.member) ? model_1.User.fromJSON(object.member) : undefined,
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : "0",
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            member_count: isSet(object.member_count)
                ? globalThis.Number(object.member_count)
                : 0,
            event_time: isSet(object.event_time)
                ? fromJsonTimestamp(object.event_time)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.member !== undefined) {
            obj.member = model_1.User.toJSON(message.member);
        }
        if (message.biz_account_id !== "0") {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.member_count !== 0) {
            obj.member_count = Math.round(message.member_count);
        }
        if (message.event_time !== undefined) {
            obj.event_time = fromTimestamp(message.event_time).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.JoinMemberEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseJoinMemberEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.member = (object.member !== undefined && object.member !== null)
            ? model_1.User.fromPartial(object.member)
            : undefined;
        message.biz_account_id = (_b = object.biz_account_id) !== null && _b !== void 0 ? _b : "0";
        message.session_id = (_c = object.session_id) !== null && _c !== void 0 ? _c : "";
        message.member_count = (_d = object.member_count) !== null && _d !== void 0 ? _d : 0;
        message.event_time =
            (object.event_time !== undefined && object.event_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.event_time)
                : undefined;
        return message;
    },
};
function createBaseLeaveMemberEvent() {
    return {
        channel_id: "",
        member: undefined,
        biz_account_id: "0",
        by: LeaveMemberEvent_By.SELF,
        session_id: "",
        member_count: 0,
        event_time: undefined,
    };
}
exports.LeaveMemberEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.member !== undefined) {
            model_1.User.encode(message.member, writer.uint32(18).fork()).ldelim();
        }
        if (message.biz_account_id !== "0") {
            writer.uint32(24).int64(message.biz_account_id);
        }
        if (message.by !== LeaveMemberEvent_By.SELF) {
            writer.uint32(32).int32(leaveMemberEvent_ByToNumber(message.by));
        }
        if (message.session_id !== "") {
            writer.uint32(42).string(message.session_id);
        }
        if (message.member_count !== 0) {
            writer.uint32(48).int32(message.member_count);
        }
        if (message.event_time !== undefined) {
            timestamp_1.Timestamp.encode(message.event_time, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLeaveMemberEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.member = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.by = leaveMemberEvent_ByFromJSON(reader.int32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.member_count = reader.int32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.event_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            member: isSet(object.member) ? model_1.User.fromJSON(object.member) : undefined,
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : "0",
            by: isSet(object.by)
                ? leaveMemberEvent_ByFromJSON(object.by)
                : LeaveMemberEvent_By.SELF,
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            member_count: isSet(object.member_count)
                ? globalThis.Number(object.member_count)
                : 0,
            event_time: isSet(object.event_time)
                ? fromJsonTimestamp(object.event_time)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.member !== undefined) {
            obj.member = model_1.User.toJSON(message.member);
        }
        if (message.biz_account_id !== "0") {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.by !== LeaveMemberEvent_By.SELF) {
            obj.by = leaveMemberEvent_ByToJSON(message.by);
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.member_count !== 0) {
            obj.member_count = Math.round(message.member_count);
        }
        if (message.event_time !== undefined) {
            obj.event_time = fromTimestamp(message.event_time).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.LeaveMemberEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseLeaveMemberEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.member = (object.member !== undefined && object.member !== null)
            ? model_1.User.fromPartial(object.member)
            : undefined;
        message.biz_account_id = (_b = object.biz_account_id) !== null && _b !== void 0 ? _b : "0";
        message.by = (_c = object.by) !== null && _c !== void 0 ? _c : LeaveMemberEvent_By.SELF;
        message.session_id = (_d = object.session_id) !== null && _d !== void 0 ? _d : "";
        message.member_count = (_e = object.member_count) !== null && _e !== void 0 ? _e : 0;
        message.event_time =
            (object.event_time !== undefined && object.event_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.event_time)
                : undefined;
        return message;
    },
};
function createBaseRenewChannelEvent() {
    return { channel_id: "", biz_account_id: "0", session_id: "" };
}
exports.RenewChannelEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.biz_account_id !== "0") {
            writer.uint32(16).int64(message.biz_account_id);
        }
        if (message.session_id !== "") {
            writer.uint32(26).string(message.session_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRenewChannelEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : "0",
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.biz_account_id !== "0") {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        return obj;
    },
    create(base) {
        return exports.RenewChannelEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseRenewChannelEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.biz_account_id = (_b = object.biz_account_id) !== null && _b !== void 0 ? _b : "0";
        message.session_id = (_c = object.session_id) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseUpdateBubbleGroupEvent() {
    return {
        channel_id: "",
        biz_account_id: "0",
        bubble_group: undefined,
        session_id: "",
    };
}
exports.UpdateBubbleGroupEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.biz_account_id !== "0") {
            writer.uint32(16).int64(message.biz_account_id);
        }
        if (message.bubble_group !== undefined) {
            model_1.BubbleGroup.encode(message.bubble_group, writer.uint32(26).fork())
                .ldelim();
        }
        if (message.session_id !== "") {
            writer.uint32(34).string(message.session_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateBubbleGroupEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.bubble_group = model_1.BubbleGroup.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : "0",
            bubble_group: isSet(object.bubble_group)
                ? model_1.BubbleGroup.fromJSON(object.bubble_group)
                : undefined,
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.biz_account_id !== "0") {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.bubble_group !== undefined) {
            obj.bubble_group = model_1.BubbleGroup.toJSON(message.bubble_group);
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateBubbleGroupEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseUpdateBubbleGroupEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.biz_account_id = (_b = object.biz_account_id) !== null && _b !== void 0 ? _b : "0";
        message.bubble_group =
            (object.bubble_group !== undefined && object.bubble_group !== null)
                ? model_1.BubbleGroup.fromPartial(object.bubble_group)
                : undefined;
        message.session_id = (_c = object.session_id) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseUpdateMessageEvent() {
    return {
        channel_id: "",
        message: undefined,
        biz_account_id: undefined,
        message_id: "0",
        reason: relay_event_1.EventReason.EVENT_REASON_UNSPECIFIED,
        session_id: "",
    };
}
exports.UpdateMessageEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message !== undefined) {
            model_1.Message.encode(message.message, writer.uint32(18).fork()).ldelim();
        }
        if (message.biz_account_id !== undefined) {
            writer.uint32(24).int64(message.biz_account_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(32).int64(message.message_id);
        }
        if (message.reason !== relay_event_1.EventReason.EVENT_REASON_UNSPECIFIED) {
            writer.uint32(40).int32((0, relay_event_1.eventReasonToNumber)(message.reason));
        }
        if (message.session_id !== "") {
            writer.uint32(802).string(message.session_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateMessageEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.message = model_1.Message.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.reason = (0, relay_event_1.eventReasonFromJSON)(reader.int32());
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message: isSet(object.message)
                ? model_1.Message.fromJSON(object.message)
                : undefined,
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : undefined,
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            reason: isSet(object.reason)
                ? (0, relay_event_1.eventReasonFromJSON)(object.reason)
                : relay_event_1.EventReason.EVENT_REASON_UNSPECIFIED,
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message !== undefined) {
            obj.message = model_1.Message.toJSON(message.message);
        }
        if (message.biz_account_id !== undefined) {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.reason !== relay_event_1.EventReason.EVENT_REASON_UNSPECIFIED) {
            obj.reason = (0, relay_event_1.eventReasonToJSON)(message.reason);
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateMessageEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseUpdateMessageEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message = (object.message !== undefined && object.message !== null)
            ? model_1.Message.fromPartial(object.message)
            : undefined;
        message.biz_account_id = (_b = object.biz_account_id) !== null && _b !== void 0 ? _b : undefined;
        message.message_id = (_c = object.message_id) !== null && _c !== void 0 ? _c : "0";
        message.reason = (_d = object.reason) !== null && _d !== void 0 ? _d : relay_event_1.EventReason.EVENT_REASON_UNSPECIFIED;
        message.session_id = (_e = object.session_id) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseJoinVoiceChannelEvent() {
    return { channel_id: "", user: undefined, session_id: "" };
}
exports.JoinVoiceChannelEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.user !== undefined) {
            model_1.User.encode(message.user, writer.uint32(18).fork()).ldelim();
        }
        if (message.session_id !== "") {
            writer.uint32(26).string(message.session_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseJoinVoiceChannelEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.user = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            user: isSet(object.user) ? model_1.User.fromJSON(object.user) : undefined,
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.user !== undefined) {
            obj.user = model_1.User.toJSON(message.user);
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        return obj;
    },
    create(base) {
        return exports.JoinVoiceChannelEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseJoinVoiceChannelEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.user = (object.user !== undefined && object.user !== null)
            ? model_1.User.fromPartial(object.user)
            : undefined;
        message.session_id = (_b = object.session_id) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseTerminateVoiceChannelEvent() {
    return {
        channel_id: "",
        reason: TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED,
        session_id: "",
    };
}
exports.TerminateVoiceChannelEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.reason !==
            TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED) {
            writer.uint32(16).int32(terminateVoiceChannelReasonToNumber(message.reason));
        }
        if (message.session_id !== "") {
            writer.uint32(26).string(message.session_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTerminateVoiceChannelEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.reason = terminateVoiceChannelReasonFromJSON(reader.int32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            reason: isSet(object.reason)
                ? terminateVoiceChannelReasonFromJSON(object.reason)
                : TerminateVoiceChannelReason
                    .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED,
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.reason !==
            TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED) {
            obj.reason = terminateVoiceChannelReasonToJSON(message.reason);
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        return obj;
    },
    create(base) {
        return exports.TerminateVoiceChannelEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseTerminateVoiceChannelEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.reason = (_b = object.reason) !== null && _b !== void 0 ? _b : TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED;
        message.session_id = (_c = object.session_id) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseUserMentionEvent() {
    return {
        channel_id: "",
        message_id: "0",
        content: "",
        sender: undefined,
        notification: undefined,
    };
}
exports.UserMentionEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.content !== "") {
            writer.uint32(26).string(message.content);
        }
        if (message.sender !== undefined) {
            model_1.User.encode(message.sender, writer.uint32(34).fork()).ldelim();
        }
        if (message.notification !== undefined) {
            exports.UserMentionEvent_Notification.encode(message.notification, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserMentionEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.sender = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.notification = exports.UserMentionEvent_Notification.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            sender: isSet(object.sender) ? model_1.User.fromJSON(object.sender) : undefined,
            notification: isSet(object.notification)
                ? exports.UserMentionEvent_Notification.fromJSON(object.notification)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.sender !== undefined) {
            obj.sender = model_1.User.toJSON(message.sender);
        }
        if (message.notification !== undefined) {
            obj.notification = exports.UserMentionEvent_Notification.toJSON(message.notification);
        }
        return obj;
    },
    create(base) {
        return exports.UserMentionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseUserMentionEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.content = (_c = object.content) !== null && _c !== void 0 ? _c : "";
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? model_1.User.fromPartial(object.sender)
            : undefined;
        message.notification =
            (object.notification !== undefined && object.notification !== null)
                ? exports.UserMentionEvent_Notification.fromPartial(object.notification)
                : undefined;
        return message;
    },
};
function createBaseUserMentionEvent_Notification() {
    return {
        summary: "",
        nickname: "",
        message: "",
        large_image_url: "",
        is_circle_large_icon: false,
        target_uri: "",
        mute: false,
        silence: false,
        message_style_notification: undefined,
    };
}
exports.UserMentionEvent_Notification = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.summary !== "") {
            writer.uint32(10).string(message.summary);
        }
        if (message.nickname !== "") {
            writer.uint32(18).string(message.nickname);
        }
        if (message.message !== "") {
            writer.uint32(26).string(message.message);
        }
        if (message.large_image_url !== "") {
            writer.uint32(34).string(message.large_image_url);
        }
        if (message.is_circle_large_icon !== false) {
            writer.uint32(40).bool(message.is_circle_large_icon);
        }
        if (message.target_uri !== "") {
            writer.uint32(50).string(message.target_uri);
        }
        if (message.mute !== false) {
            writer.uint32(56).bool(message.mute);
        }
        if (message.silence !== false) {
            writer.uint32(64).bool(message.silence);
        }
        if (message.message_style_notification !== undefined) {
            exports.MessageStyleNotification.encode(message.message_style_notification, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserMentionEvent_Notification();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.summary = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.nickname = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.large_image_url = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.is_circle_large_icon = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.mute = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.silence = reader.bool();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.message_style_notification = exports.MessageStyleNotification.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            summary: isSet(object.summary) ? globalThis.String(object.summary) : "",
            nickname: isSet(object.nickname)
                ? globalThis.String(object.nickname)
                : "",
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            large_image_url: isSet(object.large_image_url)
                ? globalThis.String(object.large_image_url)
                : "",
            is_circle_large_icon: isSet(object.is_circle_large_icon)
                ? globalThis.Boolean(object.is_circle_large_icon)
                : false,
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            mute: isSet(object.mute) ? globalThis.Boolean(object.mute) : false,
            silence: isSet(object.silence)
                ? globalThis.Boolean(object.silence)
                : false,
            message_style_notification: isSet(object.message_style_notification)
                ? exports.MessageStyleNotification.fromJSON(object.message_style_notification)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.summary !== "") {
            obj.summary = message.summary;
        }
        if (message.nickname !== "") {
            obj.nickname = message.nickname;
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.large_image_url !== "") {
            obj.large_image_url = message.large_image_url;
        }
        if (message.is_circle_large_icon !== false) {
            obj.is_circle_large_icon = message.is_circle_large_icon;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.mute !== false) {
            obj.mute = message.mute;
        }
        if (message.silence !== false) {
            obj.silence = message.silence;
        }
        if (message.message_style_notification !== undefined) {
            obj.message_style_notification = exports.MessageStyleNotification.toJSON(message.message_style_notification);
        }
        return obj;
    },
    create(base) {
        return exports.UserMentionEvent_Notification.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = createBaseUserMentionEvent_Notification();
        message.summary = (_a = object.summary) !== null && _a !== void 0 ? _a : "";
        message.nickname = (_b = object.nickname) !== null && _b !== void 0 ? _b : "";
        message.message = (_c = object.message) !== null && _c !== void 0 ? _c : "";
        message.large_image_url = (_d = object.large_image_url) !== null && _d !== void 0 ? _d : "";
        message.is_circle_large_icon = (_e = object.is_circle_large_icon) !== null && _e !== void 0 ? _e : false;
        message.target_uri = (_f = object.target_uri) !== null && _f !== void 0 ? _f : "";
        message.mute = (_g = object.mute) !== null && _g !== void 0 ? _g : false;
        message.silence = (_h = object.silence) !== null && _h !== void 0 ? _h : false;
        message.message_style_notification =
            (object.message_style_notification !== undefined &&
                object.message_style_notification !== null)
                ? exports.MessageStyleNotification.fromPartial(object.message_style_notification)
                : undefined;
        return message;
    },
};
function createBaseReplyEvent() {
    return {
        channel_id: "",
        message_id: "0",
        content: "",
        sender: undefined,
        notification: undefined,
        biz_account_id: undefined,
    };
}
exports.ReplyEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.content !== "") {
            writer.uint32(26).string(message.content);
        }
        if (message.sender !== undefined) {
            model_1.User.encode(message.sender, writer.uint32(34).fork()).ldelim();
        }
        if (message.notification !== undefined) {
            exports.ReplyEvent_Notification.encode(message.notification, writer.uint32(50).fork()).ldelim();
        }
        if (message.biz_account_id !== undefined) {
            writer.uint32(56).int64(message.biz_account_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReplyEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.sender = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.notification = exports.ReplyEvent_Notification.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            sender: isSet(object.sender) ? model_1.User.fromJSON(object.sender) : undefined,
            notification: isSet(object.notification)
                ? exports.ReplyEvent_Notification.fromJSON(object.notification)
                : undefined,
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.sender !== undefined) {
            obj.sender = model_1.User.toJSON(message.sender);
        }
        if (message.notification !== undefined) {
            obj.notification = exports.ReplyEvent_Notification.toJSON(message.notification);
        }
        if (message.biz_account_id !== undefined) {
            obj.biz_account_id = message.biz_account_id;
        }
        return obj;
    },
    create(base) {
        return exports.ReplyEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseReplyEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.content = (_c = object.content) !== null && _c !== void 0 ? _c : "";
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? model_1.User.fromPartial(object.sender)
            : undefined;
        message.notification =
            (object.notification !== undefined && object.notification !== null)
                ? exports.ReplyEvent_Notification.fromPartial(object.notification)
                : undefined;
        message.biz_account_id = (_d = object.biz_account_id) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function createBaseReplyEvent_Notification() {
    return {
        nickname: "",
        profile_image_url: "",
        mute: false,
        readonly: false,
        summary: "",
        message_style_notification: undefined,
    };
}
exports.ReplyEvent_Notification = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.nickname !== "") {
            writer.uint32(10).string(message.nickname);
        }
        if (message.profile_image_url !== "") {
            writer.uint32(18).string(message.profile_image_url);
        }
        if (message.mute !== false) {
            writer.uint32(24).bool(message.mute);
        }
        if (message.readonly !== false) {
            writer.uint32(32).bool(message.readonly);
        }
        if (message.summary !== "") {
            writer.uint32(42).string(message.summary);
        }
        if (message.message_style_notification !== undefined) {
            exports.MessageStyleNotification.encode(message.message_style_notification, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReplyEvent_Notification();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.nickname = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.profile_image_url = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.mute = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.readonly = reader.bool();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.summary = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.message_style_notification = exports.MessageStyleNotification.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            nickname: isSet(object.nickname)
                ? globalThis.String(object.nickname)
                : "",
            profile_image_url: isSet(object.profile_image_url)
                ? globalThis.String(object.profile_image_url)
                : "",
            mute: isSet(object.mute) ? globalThis.Boolean(object.mute) : false,
            readonly: isSet(object.readonly)
                ? globalThis.Boolean(object.readonly)
                : false,
            summary: isSet(object.summary) ? globalThis.String(object.summary) : "",
            message_style_notification: isSet(object.message_style_notification)
                ? exports.MessageStyleNotification.fromJSON(object.message_style_notification)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.nickname !== "") {
            obj.nickname = message.nickname;
        }
        if (message.profile_image_url !== "") {
            obj.profile_image_url = message.profile_image_url;
        }
        if (message.mute !== false) {
            obj.mute = message.mute;
        }
        if (message.readonly !== false) {
            obj.readonly = message.readonly;
        }
        if (message.summary !== "") {
            obj.summary = message.summary;
        }
        if (message.message_style_notification !== undefined) {
            obj.message_style_notification = exports.MessageStyleNotification.toJSON(message.message_style_notification);
        }
        return obj;
    },
    create(base) {
        return exports.ReplyEvent_Notification.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseReplyEvent_Notification();
        message.nickname = (_a = object.nickname) !== null && _a !== void 0 ? _a : "";
        message.profile_image_url = (_b = object.profile_image_url) !== null && _b !== void 0 ? _b : "";
        message.mute = (_c = object.mute) !== null && _c !== void 0 ? _c : false;
        message.readonly = (_d = object.readonly) !== null && _d !== void 0 ? _d : false;
        message.summary = (_e = object.summary) !== null && _e !== void 0 ? _e : "";
        message.message_style_notification =
            (object.message_style_notification !== undefined &&
                object.message_style_notification !== null)
                ? exports.MessageStyleNotification.fromPartial(object.message_style_notification)
                : undefined;
        return message;
    },
};
function createBaseTargetEvent() {
    return {
        new_message: undefined,
        read_message: undefined,
        join_member: undefined,
        leave_member: undefined,
        renew_channel: undefined,
        update_bubble_group: undefined,
        update_message: undefined,
        join_voice_channel: undefined,
        terminate_voice_channel: undefined,
        user_mention: undefined,
        reply: undefined,
    };
}
exports.TargetEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.new_message !== undefined) {
            exports.NewMessageEvent.encode(message.new_message, writer.uint32(10).fork())
                .ldelim();
        }
        if (message.read_message !== undefined) {
            exports.ReadMessageEvent.encode(message.read_message, writer.uint32(18).fork())
                .ldelim();
        }
        if (message.join_member !== undefined) {
            exports.JoinMemberEvent.encode(message.join_member, writer.uint32(26).fork())
                .ldelim();
        }
        if (message.leave_member !== undefined) {
            exports.LeaveMemberEvent.encode(message.leave_member, writer.uint32(34).fork())
                .ldelim();
        }
        if (message.renew_channel !== undefined) {
            exports.RenewChannelEvent.encode(message.renew_channel, writer.uint32(42).fork())
                .ldelim();
        }
        if (message.update_bubble_group !== undefined) {
            exports.UpdateBubbleGroupEvent.encode(message.update_bubble_group, writer.uint32(50).fork()).ldelim();
        }
        if (message.update_message !== undefined) {
            exports.UpdateMessageEvent.encode(message.update_message, writer.uint32(58).fork()).ldelim();
        }
        if (message.join_voice_channel !== undefined) {
            exports.JoinVoiceChannelEvent.encode(message.join_voice_channel, writer.uint32(66).fork()).ldelim();
        }
        if (message.terminate_voice_channel !== undefined) {
            exports.TerminateVoiceChannelEvent.encode(message.terminate_voice_channel, writer.uint32(74).fork()).ldelim();
        }
        if (message.user_mention !== undefined) {
            exports.UserMentionEvent.encode(message.user_mention, writer.uint32(82).fork())
                .ldelim();
        }
        if (message.reply !== undefined) {
            exports.ReplyEvent.encode(message.reply, writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTargetEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.new_message = exports.NewMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.read_message = exports.ReadMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.join_member = exports.JoinMemberEvent.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.leave_member = exports.LeaveMemberEvent.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.renew_channel = exports.RenewChannelEvent.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.update_bubble_group = exports.UpdateBubbleGroupEvent.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.update_message = exports.UpdateMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.join_voice_channel = exports.JoinVoiceChannelEvent.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.terminate_voice_channel = exports.TerminateVoiceChannelEvent.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.user_mention = exports.UserMentionEvent.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.reply = exports.ReplyEvent.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            new_message: isSet(object.new_message)
                ? exports.NewMessageEvent.fromJSON(object.new_message)
                : undefined,
            read_message: isSet(object.read_message)
                ? exports.ReadMessageEvent.fromJSON(object.read_message)
                : undefined,
            join_member: isSet(object.join_member)
                ? exports.JoinMemberEvent.fromJSON(object.join_member)
                : undefined,
            leave_member: isSet(object.leave_member)
                ? exports.LeaveMemberEvent.fromJSON(object.leave_member)
                : undefined,
            renew_channel: isSet(object.renew_channel)
                ? exports.RenewChannelEvent.fromJSON(object.renew_channel)
                : undefined,
            update_bubble_group: isSet(object.update_bubble_group)
                ? exports.UpdateBubbleGroupEvent.fromJSON(object.update_bubble_group)
                : undefined,
            update_message: isSet(object.update_message)
                ? exports.UpdateMessageEvent.fromJSON(object.update_message)
                : undefined,
            join_voice_channel: isSet(object.join_voice_channel)
                ? exports.JoinVoiceChannelEvent.fromJSON(object.join_voice_channel)
                : undefined,
            terminate_voice_channel: isSet(object.terminate_voice_channel)
                ? exports.TerminateVoiceChannelEvent.fromJSON(object.terminate_voice_channel)
                : undefined,
            user_mention: isSet(object.user_mention)
                ? exports.UserMentionEvent.fromJSON(object.user_mention)
                : undefined,
            reply: isSet(object.reply)
                ? exports.ReplyEvent.fromJSON(object.reply)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.new_message !== undefined) {
            obj.new_message = exports.NewMessageEvent.toJSON(message.new_message);
        }
        if (message.read_message !== undefined) {
            obj.read_message = exports.ReadMessageEvent.toJSON(message.read_message);
        }
        if (message.join_member !== undefined) {
            obj.join_member = exports.JoinMemberEvent.toJSON(message.join_member);
        }
        if (message.leave_member !== undefined) {
            obj.leave_member = exports.LeaveMemberEvent.toJSON(message.leave_member);
        }
        if (message.renew_channel !== undefined) {
            obj.renew_channel = exports.RenewChannelEvent.toJSON(message.renew_channel);
        }
        if (message.update_bubble_group !== undefined) {
            obj.update_bubble_group = exports.UpdateBubbleGroupEvent.toJSON(message.update_bubble_group);
        }
        if (message.update_message !== undefined) {
            obj.update_message = exports.UpdateMessageEvent.toJSON(message.update_message);
        }
        if (message.join_voice_channel !== undefined) {
            obj.join_voice_channel = exports.JoinVoiceChannelEvent.toJSON(message.join_voice_channel);
        }
        if (message.terminate_voice_channel !== undefined) {
            obj.terminate_voice_channel = exports.TerminateVoiceChannelEvent.toJSON(message.terminate_voice_channel);
        }
        if (message.user_mention !== undefined) {
            obj.user_mention = exports.UserMentionEvent.toJSON(message.user_mention);
        }
        if (message.reply !== undefined) {
            obj.reply = exports.ReplyEvent.toJSON(message.reply);
        }
        return obj;
    },
    create(base) {
        return exports.TargetEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseTargetEvent();
        message.new_message =
            (object.new_message !== undefined && object.new_message !== null)
                ? exports.NewMessageEvent.fromPartial(object.new_message)
                : undefined;
        message.read_message =
            (object.read_message !== undefined && object.read_message !== null)
                ? exports.ReadMessageEvent.fromPartial(object.read_message)
                : undefined;
        message.join_member =
            (object.join_member !== undefined && object.join_member !== null)
                ? exports.JoinMemberEvent.fromPartial(object.join_member)
                : undefined;
        message.leave_member =
            (object.leave_member !== undefined && object.leave_member !== null)
                ? exports.LeaveMemberEvent.fromPartial(object.leave_member)
                : undefined;
        message.renew_channel =
            (object.renew_channel !== undefined && object.renew_channel !== null)
                ? exports.RenewChannelEvent.fromPartial(object.renew_channel)
                : undefined;
        message.update_bubble_group = (object.update_bubble_group !== undefined &&
            object.update_bubble_group !== null)
            ? exports.UpdateBubbleGroupEvent.fromPartial(object.update_bubble_group)
            : undefined;
        message.update_message =
            (object.update_message !== undefined && object.update_message !== null)
                ? exports.UpdateMessageEvent.fromPartial(object.update_message)
                : undefined;
        message.join_voice_channel = (object.join_voice_channel !== undefined &&
            object.join_voice_channel !== null)
            ? exports.JoinVoiceChannelEvent.fromPartial(object.join_voice_channel)
            : undefined;
        message.terminate_voice_channel =
            (object.terminate_voice_channel !== undefined &&
                object.terminate_voice_channel !== null)
                ? exports.TerminateVoiceChannelEvent.fromPartial(object.terminate_voice_channel)
                : undefined;
        message.user_mention =
            (object.user_mention !== undefined && object.user_mention !== null)
                ? exports.UserMentionEvent.fromPartial(object.user_mention)
                : undefined;
        message.reply = (object.reply !== undefined && object.reply !== null)
            ? exports.ReplyEvent.fromPartial(object.reply)
            : undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (globalThis.Number(t.seconds) || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new globalThis.Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
